import React from 'react';
import cx from 'classnames';

export enum LockIconVariant {
  White = 'white',
  Black = 'black',
  Yellow = 'yellow',
  Grey = 'grey',
}
export interface LockIconProps {
  variant?: LockIconVariant;
  className?: string;
  onClick?: () => void;
}

export default function LockIcon({
  variant = LockIconVariant.White,
  className,
  onClick,
}: LockIconProps) {
  return (
    <i
      className={cx('icon icon-locked w-6 h-6', className, {
        '!bg-black': !variant,
        '!bg-white': variant == LockIconVariant.White,
        '!bg-neutral-500': variant == LockIconVariant.Grey,
        '!v2-bg-yellow-500': variant == LockIconVariant.Yellow,
      })}
      onClick={onClick}
    />
  );
}
